import { useCrmInsights } from '../../../hooks/crm/useCrmQueries';

type Props = {
  managerId?: number | null;
  days?: number;
};

export function CrmInsightsStrip({ managerId, days = 30 }: Props) {
  const { data } = useCrmInsights(days, managerId);
  if (!data) return null;

  const items = [
    { label: 'Лиды', value: data.leads_created, sub: `${data.lead_conversion_pct}% → заказ` },
    { label: 'Win', value: `${data.win_rate_pct}%`, sub: `${data.paid_count} оплач.` },
    { label: 'Выручка', value: `${Math.round(data.revenue_paid).toLocaleString('ru-RU')} ₽`, sub: `${data.days}д` },
    { label: 'Просроч.', value: data.overdue_open_tasks, sub: 'задачи' },
    ...(data.leads_without_task_pct != null
      ? [{ label: 'Без задачи', value: `${data.leads_without_task_pct}%`, sub: 'лиды' }]
      : []),
    ...(data.avg_hours_to_first_call != null
      ? [{ label: '1-й звонок', value: `${data.avg_hours_to_first_call}ч`, sub: 'среднее' }]
      : []),
  ];

  return (
    <div className="grid grid-cols-2 gap-2 sm:grid-cols-3">
      {items.map((it) => (
        <div
          key={it.label}
          className="rounded-xl px-3 py-2 min-w-0"
          style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid var(--border-subtle)' }}
        >
          <p className="text-[10px] font-bold uppercase truncate" style={{ color: 'var(--text-3)' }}>
            {it.label}
          </p>
          <p className="text-sm font-black truncate" style={{ color: 'var(--cyan-bright)' }}>
            {it.value}
          </p>
          <p className="text-[10px] truncate" style={{ color: 'var(--text-3)' }}>
            {it.sub}
          </p>
        </div>
      ))}
    </div>
  );
}
